import { createStyles, Theme } from '@material-ui/core'

const notificationsModalStyles = (theme: Theme) => createStyles({

})

export default notificationsModalStyles
